// Creating a number of non-nullable versions
// Its very likely that you will want to use these over the default ones from use-query-params
// Context: https://github.com/pbeshai/use-query-params/issues/165

import {
  StringParam as DefaultStringParam,
  NumberParam as DefaultNumberParam,
  ObjectParam as DefaultObjectParam,
  ArrayParam as DefaultArrayParam,
  NumericArrayParam as DefaultNumericArrayParam,
  DateParam as DefaultDateParam,
  DateTimeParam as DefaultDateTimeParam,
  BooleanParam as DefaultBooleanParam,
  NumericObjectParam as DefaultNumericObjectParam,
  DelimitedArrayParam as DefaultDelimitedArrayParam,
  DelimitedNumericArrayParam as DefaultDelimitedNumericArrayParam,
  createEnumArrayParam as defaultCreateEnumArrayParam,
  createEnumDelimitedArrayParam as defaultCreateEnumDelimitedArrayParam,
  createEnumParam as defaultCreateEnumParam,
  withDefault,
  QueryParamConfig,
} from 'use-query-params';

export const StringParam = withDefault(
  DefaultStringParam,
  undefined,
) as QueryParamConfig<string | undefined>;

export const NumberParam = withDefault(
  DefaultNumberParam,
  undefined,
) as QueryParamConfig<number | undefined>;

export const ObjectParam = withDefault(
  DefaultObjectParam,
  undefined,
) as QueryParamConfig<
  | {
      [key: string]: string | undefined;
    }
  | undefined
>;
export const ArrayParam = withDefault(
  DefaultArrayParam,
  undefined,
) as QueryParamConfig<Array<string> | undefined>;

export const NumericArrayParam = withDefault(
  DefaultNumericArrayParam,
  undefined,
) as QueryParamConfig<Array<number> | undefined>;

export const DateParam = withDefault(
  DefaultDateParam,
  undefined,
) as QueryParamConfig<Date | undefined>;

export const DateTimeParam = withDefault(
  DefaultDateTimeParam,
  undefined,
) as QueryParamConfig<Date | undefined>;

export const BooleanParam = withDefault(
  DefaultBooleanParam,
  undefined,
) as QueryParamConfig<boolean | undefined>;

export const NumericObjectParam = withDefault(
  DefaultNumericObjectParam,
  undefined,
) as QueryParamConfig<
  | {
      [key: string]: number | undefined;
    }
  | undefined
>;

export const DelimitedArrayParam = withDefault(
  DefaultDelimitedArrayParam,
  undefined,
) as QueryParamConfig<Array<number> | undefined>;

export const DelimitedNumericArrayParam = withDefault(
  DefaultDelimitedNumericArrayParam,
  undefined,
) as QueryParamConfig<Array<number> | undefined>;

export const createEnumArrayParam = defaultCreateEnumArrayParam as <
  T extends string,
>(
  enumValues: Array<T>,
) => QueryParamConfig<Array<T> | undefined>;

export const createEnumDelimitedArrayParam =
  defaultCreateEnumDelimitedArrayParam as <T extends string>(
    enumValues: Array<T>,
    entrySeparator?: string,
  ) => QueryParamConfig<Array<T> | undefined>;

export const createEnumParam = defaultCreateEnumParam as <T extends string>(
  enumValues: Array<T>,
) => QueryParamConfig<T | undefined>;
